<script setup lang="ts">
import { computed } from "vue";

import { useAircraftStats } from "@/queries/aircraft";

import StatCard from "./StatCard.vue";
const props = defineProps<{
	aircraftId: string;
}>();
  
const { data, isLoading } = useAircraftStats(props.aircraftId);
  
const homeAirport = computed(() => {
	const top = data.value?.topAirports.at(0);
  
	if (isLoading.value) {
		return {
			description: "...",
			label: "...",
		};
	}
	if (top) {
		const {
			city, locId, name, state, icaoId,
		} = top;
		const code = locId ?? icaoId;
		const label = code === name ? code : `${code} - ${name}`;
		const parts = [
			city,
			state,
		];
		const description = parts.filter(Boolean).join(", ");
		return {
			code,
			description,
			label,
		};
	}
  
	return {
		description: "Not enough data to determine home airport",
		label: "Unknown",
		code: null,
	};
});

</script>
    
<template>
  <StatCard
    label="Home Airport"
    :value="homeAirport.label"
    :sub-value="homeAirport.description"
    :is-loading="isLoading"
    :to="homeAirport.code ? `/airports/${homeAirport.code}` : undefined"
  />
</template>